import DashboardShell from '@/components/DashboardShell';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import ProtectedRoute from '@/components/auth/ProtectedRoute';
import { PermissionsProvider } from '@/contexts/PermissionsContext';
import { SidebarProvider } from '@/providers/SidebarProvider';
import { UploadQueueWidgetProvider } from '@/contexts/UploadQueueWidgetContext';

import { Outlet } from 'react-router-dom';

export const DashboardLayout: React.FC = () => {
  return (
    <PermissionsProvider>
      <ProtectedRoute>
        <ErrorBoundary>
          <SidebarProvider>
            <UploadQueueWidgetProvider>
              <DashboardShell>
                <Outlet />
              </DashboardShell>
            </UploadQueueWidgetProvider>
          </SidebarProvider>
        </ErrorBoundary>
      </ProtectedRoute>
    </PermissionsProvider>
  );
};
